<template>
    <div class="field has-addons" :class="{ 'no-margin': noMargin }">
        <div class="control has-icons-left" :class="{ 'is-loading': searchRefreshing, 'is-expanded': isExpanded }">
            <input
                ref="input"
                type="text"
                class="input search-input"
                :class="[searchQueryInputClass, inputSize]"
                :placeholder="placeholder || translate('common.find')"
                :value="searchQuery"
                @input="updateSearchQuery($event.target.value)"
            />
            <span class="icon is-small is-left">
                <i class="fa fa-search" />
            </span>
        </div>
        <div class="control">
            <button class="button" @click="clearSearch()" :class="inputSize">
                <i class="fa fa-times" />
            </button>
        </div>
    </div>
</template>

<script>
    import translatorMixin from "./translatorMixin";
    import debounce from "lodash.debounce";

    export default {
        name: "query-input",
        mixins: [translatorMixin],
        props: {
            modelValue: { type: String, default: "" },
            searchQueryInputClass: { type: String, default: "" },
            searchRefreshing: { type: Boolean, default: false },
            size: { type: String, default: "" },
            placeholder: { type: String, default: "" },
            noMargin: { type: Boolean, default: false },
            isExpanded: { type: Boolean, default: false },
            debounceMs: { type: Number, default: 250 },
        },
        data() {
            return {
                debouncedUpdate: null,
            };
        },
        computed: {
            searchQuery: {
                get() {
                    return this.modelValue;
                },
                set(newValue) {
                    this.updateSearchQuery(newValue);
                },
            },
            inputSize() {
                if (this.size) {
                    return this.size;
                }
                return "";
            },
        },
        created() {
            this.createDebouncedUpdate();
        },
        beforeUnmount() {
            this.debouncedUpdate?.cancel();
        },
        methods: {
            createDebouncedUpdate() {
                this.debouncedUpdate = debounce(value => this.$emit("update:modelValue", value), this.debounceMs);
            },
            focus() {
                this.$refs.input.focus();
            },
            updateSearchQuery(value) {
                if (this.debounceMs === 0) {
                    this.debouncedUpdate?.cancel();
                    this.$emit("update:modelValue", value);
                    return;
                }

                this.debouncedUpdate?.(value);
            },
            clearSearch() {
                this.debouncedUpdate?.cancel();
                this.$emit("update:modelValue", "");
                this.$refs.input.focus();
            },
        },
    };
</script>

<style scoped>
    .no-margin {
        margin-bottom: 0;
    }
</style>
